import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  Pagination,
  Tooltip,
  FormControl,
} from "react-bootstrap";
import { getAllVoucher, deleteVoucher } from "../../../Listfunction";
import LoadingSpinner from "views/Components/loadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
class viewCouponCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      loading: false,
      p_couponid: null,
      tabledata: [],
      page: 1,
      _notificationSystem: null,
      alert: null,
      noRecordFound: false,
      totpageNo: "",
      title_search: "",
    };
    this.deleteVoucher = this.deleteVoucher.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  selectedVoucher(cus) {
    localStorage.setItem("vch_ID", cus);
    this.props.history.push("/admin/editvoucher");
  }

  async componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    this.searchData();
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleSuccess(position, message) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{message}</div>,
      level: level,
      position: position,
      autoDismiss: 3,
    });
  }

  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }

  searchdata(e) {
    this.setState({ page: 1 });
    this.searchData();
  }

  resetSearch(e) {
    this.setState({
      title_search: "",
    });

    setTimeout(
      function () {
        this.searchData();
      }.bind(this),
      300
    );
  }

  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ noRecordFound: false });

    this.setState({ loading: true }, () => {
      getAllVoucher(obj, this.state.page, this.state.title_search)
        .then((response1) => {
          var data = response1.data;
          console.log(data);
          if (data.data.length == 0) {
            this.setState({ noRecordFound: true });
          }

          var $no_pages = [];
          let serach_string = "";
          for (var i = 1; i <= data.last_page; i++) {
            if (serach_string == "") {
              $no_pages.push(i);
            } else {
              $no_pages.push(i);
            }
          }

          if (data.current_page == data.last_page) {
            this.setState({ prevdisabled: null });
            this.setState({ nextdisabled: "1" });
          } else if (data.current_page == 1) {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: "1" });
          } else {
            this.setState({ nextdisabled: null });
            this.setState({ prevdisabled: null });
          }
          if (data.last_page == 1) {
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          if (data.data.length == 0) {
            $no_pages = [];
            this.setState({ nextdisabled: 1 });
            this.setState({ prevdisabled: 1 });
          }
          this.setState({ currentPage: data.current_page });
          if (data.next_page_url != null) {
            if (serach_string == "") {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            } else {
              this.setState({
                nextpage: this.subStrAfterChars(data.next_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ nextpage: "#" });
          }
          if (data.prev_page_url != null) {
            if (serach_string == "") {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            } else {
              this.setState({
                prevpage: this.subStrAfterChars(data.prev_page_url, "=", "b"),
              });
            }
          } else {
            this.setState({ prevpage: "#" });
          }
          this.setState({ paginationData: $no_pages });

          this.setState({
            loading: false,
            tabledata: data.data,
            totpageNo: data.last_page,
          });
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    });
  }

  warningWithConfirmAndCancelMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteVoucher(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this voucher detail !
        </SweetAlert>
      ),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  deleteVoucher(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    deleteVoucher(obj, id)
      .then(() => {
        this.setState({
          alert: null,
        });
        this.handleSuccess("bl", "Voucher deleted successfully.");
        this.searchData();
      })
      .catch((error) => {
        this.handleNetworkError("bl", error);
      });
  }

  addVoucher() {
    this.props.history.push("/admin/addvoucher");
  }

  render() {
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    var c = 1;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <NotificationSystem ref="notificationSystem" style={style} />
          <Card
            tableFullWidth
            content={
              <div className="voucher_list_function">
                <Row className="text-right">
                  <Button
                    className="Add_NewItem_Btn btn-color btn-fill"
                    onClick={this.addVoucher.bind(this)}
                  >
                    Add Voucher <i className="fa fa-plus"></i>
                  </Button>
                  <br />
                  &nbsp;
                </Row>

                <Row className="common_filter_container">
                  <Col md={4} sm={6}>
                    <FormControl
                      name="title_search"
                      value={this.state.title_search || ""}
                      placeholder="Title"
                      onChange={this.onChange}
                      type="text"
                    />
                  </Col>
                  <Col md={4} sm={6} style={{ margin: "0.4rem" }}>
                    <Button
                      class="btn-color"
                      fill
                      onClick={this.searchdata.bind(
                        this,
                        this.state.title_search,
                        1
                      )}
                    >
                      Filter
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      class="btn-color"
                      fill
                      onClick={this.resetSearch.bind(this)}
                    >
                      Reset
                    </Button>
                  </Col>
                </Row>

                <Row>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Title</th>
                        <th>Description</th>
                        <th>Price</th>
                        <th className="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.loading ? (
                        <tr>
                          <td colspan="10">
                            <LoadingSpinner />
                          </td>
                        </tr>
                      ) : this.state.noRecordFound ? (
                        <tr>
                          <td colspan="10">
                            <center>No record found</center>
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {this.state.tabledata.map((cus) => (
                            <tr>
                              <td>{cus.title}</td>
                              <td>{cus.description}</td>
                              <td>{cus.price}</td>
                              <td className="td-actions text-right no-padding">
                                <OverlayTrigger placement="top" overlay={edit}>
                                  <Button
                                    simple
                                    bsStyle="success"
                                    onClick={this.selectedVoucher.bind(
                                      this,
                                      cus.id
                                    )}
                                    bsSize="xs"
                                  >
                                    <i className="fa fa-edit" />
                                  </Button>
                                </OverlayTrigger>

                                <OverlayTrigger
                                  placement="top"
                                  overlay={remove}
                                >
                                  <Button
                                    simple
                                    bsStyle="danger"
                                    onClick={this.warningWithConfirmAndCancelMessage.bind(
                                      this,
                                      cus.id
                                    )}
                                    bsSize="xs"
                                  >
                                    <i className="fa fa-times" />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                  {this.state.loading
                    ? ""
                    : this.state.noRecordFound
                    ? ""
                    : this.state.totpageNo > 1 && (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              dataUrl={this.state.prevpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                dataUrl={url}
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              dataUrl={this.state.nextpage}
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}
                </Row>
              </div>
            }
          />
        </Grid>
      </div>
    );
  }
}

export default viewCouponCode;
